import api from '@/api';
import { API_BASE_URL } from '..';
import {
  SignatureCreateInterface,
  SignatureRequestInterface,
  SignatureResponseInterface,
} from './ChecklistSignature.types';

const BASE_URL = `${API_BASE_URL}/Checklist/`;

export async function getSignature(params: SignatureRequestInterface) {
  const response = (await api.get(
    `${BASE_URL}GetSignature`,
    params,
  )) as unknown;
  return response as SignatureResponseInterface;
}

export async function createSignature(params: SignatureCreateInterface) {
  const response = (await api.post(`${BASE_URL}Signature`, params)) as unknown;
  return response as SignatureResponseInterface;
}
